import React from 'react';

import {checkIfHasPermissions} from '../../../../../components/Menu/Utils/commonFunctions';
import Tabs from '../../../../../components/Tabs/Tabs';
import {PermissionEnum} from '../../../../../constants/permissionsEnum';
import TranslatedText from '../../../../../libraries/I18N/TranslatedText';
import {accessModule} from '../../../../../store/companyStore/companyDetailsStore';
import {shouldBlockModuleAccess} from '../../../../../utils/SubscriptionHelper';
import {IFacilityDetail} from '../interface/commonI';
import Electricity from '../Utils/Electricity';
import FuelConsumptions from '../Utils/FuelConsumptions';
import Waste from '../Utils/Waste';
import Water from '../Utils/Water';

const Utility: React.FC<{
  selectedYear: string;
  facilityId: string;
  facilityDetail: IFacilityDetail;
}> = ({facilityId, selectedYear, facilityDetail}) => {
  const UtilityTab = [
    {
      id: 'fuelConsumption',
      name: <TranslatedText translationKey="Fuel Consumption" />,
      component: (
        <FuelConsumptions selectedYear={selectedYear} facilityId={facilityId} />
      ),
      hidden: !checkIfHasPermissions(PermissionEnum.OrgInfraUtilFuel),
      isBlock: false
    },
    {
      id: 'electric',
      name: <TranslatedText translationKey="Electricity" />,
      component: (
        <Electricity
          selectedYear={selectedYear}
          facilityId={facilityId}
          // facilityDetail={facilityDetail}
        />
      ),
      hidden: !checkIfHasPermissions(PermissionEnum.OrgInfraUtilElectricity),
      isBlock: false
    },
    {
      id: 'water',
      name: <TranslatedText translationKey="Water" />,
      component: facilityDetail?.isLeased ? (
        <></>
      ) : (
        <Water selectedYear={selectedYear} facilityId={facilityId} />
      ),
      disabled: facilityDetail?.isLeased,
      hidden: !checkIfHasPermissions(PermissionEnum.OrgManagerWater),
      isBlock: false
    },
    {
      id: 'waste_scope3',
      name: <TranslatedText translationKey="Waste" />,
      component: <Waste selectedYear={selectedYear} facilityId={facilityId} />,
      hidden: !checkIfHasPermissions(PermissionEnum.OrgManagerWaste),
      isBlock: shouldBlockModuleAccess(accessModule.scope3)
    }
  ].filter((item) => !item.hidden);

  return (
    <>
      <Tabs array={UtilityTab} type="card" />
    </>
  );
};

export default Utility;
